/**
 * Operational day boundary helpers.
 *
 * Shelter operations roll over at 2:00 AM local time (matching the nightly
 * bed-count cadence). Anything that happened on or after the most recent
 * 2:00 AM is "today"; before that boundary belongs to the previous
 * operational day.
 */

export const OPERATIONAL_DAY_ROLLOVER_HOUR = 2;

/** Returns the Date marking the start (2:00 AM local) of the current operational day. */
export const getCurrentOperationalDayStart = (now: Date = new Date()): Date => {
  const start = new Date(now);
  start.setHours(OPERATIONAL_DAY_ROLLOVER_HOUR, 0, 0, 0);
  if (now.getTime() < start.getTime()) {
    // Before 2 AM — operational day started at 2 AM yesterday
    start.setDate(start.getDate() - 1);
  }
  return start;
};

/** True when the given timestamp falls within the current operational day. */
export const isWithinCurrentOperationalDay = (
  ts: string | Date | null | undefined,
  now: Date = new Date(),
): boolean => {
  if (!ts) return false;
  const d = ts instanceof Date ? ts : new Date(ts);
  if (Number.isNaN(d.getTime())) return false;
  return d.getTime() >= getCurrentOperationalDayStart(now).getTime();
};
